import { inject, Injectable } from "@angular/core";
import { DriverDto } from "@dtos/driver.dto";
import { ApiService } from "@services/api.service";
import { EndPoints } from "@services/EndPoints";

//INTERFAZ PARA RESPUESTA PAGINADA DE CONDUCTORES AUTORIZADOS
export interface PaginatedAuthorizedDriversResponse {
  count: number;
  total_pages: number;
  next: string | null;
  previous: string | null;
  results: DriverDto[];
}

@Injectable({ providedIn: 'root' })
export class AuthorizedDriversProvider {

  private readonly api = inject(ApiService);

  /**
   * OBTENER CONDUCTORES AUTORIZADOS DE UN CONDUCTOR
   * @param driverId - ID DEL CONDUCTOR
   * @param queryParams - OBJETO CON TODOS LOS PARAMETROS DE CONSULTA (filtros, paginación, etc.)
   * @returns RESPUESTA PAGINADA CON CONDUCTORES AUTORIZADOS
   */
  async getAuthorizedDrivers(driverId: number, queryParams: Record<string, any> = {}): Promise<PaginatedAuthorizedDriversResponse | null> {
    try {
      //ESTABLECER VALORES POR DEFECTO SI NO SE PROPORCIONAN
      const params = {
        page: 1,
        page_size: 50,
        ...queryParams
      };

      //REALIZAR LA PETICION AL BACKEND
      return await this.api.get<PaginatedAuthorizedDriversResponse>({
        url: EndPoints.driverAuthorizedDrivers.replace('{driverId}', String(driverId)),
        queryParams: params
      });
    } catch (error) {
      console.error('Error al obtener conductores autorizados:', error);
      return null;
    }
  }
}
